import React from 'react';
import { Icon, Step } from 'semantic-ui-react';
import WizardStepTitle from './WizardStepTitle';
import WizardStepDescription from './WizardStepDescription';

const WizardStep = ({
  activeStep,
  disabled,
  entity,
  icon,
  index,
  onClick,
  steps,
  title,
  description,
}) => (
  <Step
    className="aridhia-wizard-step"
    active={steps[index] === activeStep}
    onClick={(index < steps.indexOf(activeStep) && !disabled) ? () => onClick(index) : undefined}
  >
    <Icon name={icon} />
    <Step.Content>
      {title && (<Step.Title content={title} />)}
      {!title && entity && (<WizardStepTitle entity={entity} index={index} steps={steps} />)}
      {description && (<Step.Description content={description} />)}
      {!description && entity && (<WizardStepDescription entity={entity} index={index} steps={steps} />)}
    </Step.Content>
  </Step>
);

export default WizardStep;
